import { render, staticRenderFns } from "./RightMenuSettingMenu.vue?vue&type=template&id=08cfd666"
import script from "./RightMenuSettingMenu.vue?vue&type=script&lang=js"
export * from "./RightMenuSettingMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports